<template>
  <v-layout align-center justify-center pa-5 wrap>
    <v-flex lg6 md8 xs12>
      <span class="header headline mb-10">{{ content.title }}</span>
      <p class="header">{{ content.description }}</p>
      <template v-if="content.url">
        <template v-if="!isMobile">
          <v-card height="72vh" style="overflow-y: hidden">
            <div
              style="width: 100%; height: 100%; overflow-y: scroll;"
            >
              <iframe
                type="application/pdf"
                v-on:load="loaded = true"
                v-show="loaded"
                style="min-height: 100%; min-width: 100%;"
                :src="content.url"
              />
              <div v-if="!loaded">
                <v-skeleton-loader :key="index" v-for="index in 5" type="article" />
              </div>
            </div>
          </v-card>
        </template>
        <template v-else>
          <v-card
            style="border-radius: 10px; cursor: pointer"
            flat
            color="#dddddd"
            class="pa-5 my-2"
            @click.stop="didTapDownloadFile"
          >
            <v-layout justify-center align-center column>
              <v-btn @click.stop="didTapDownloadFile" fab color="primary" class="mb-2">
                <v-icon>file_download</v-icon>
              </v-btn>
              <span class="primary--text">{{"Obter PDF"}}</span>
            </v-layout>
          </v-card>
        </template>
      </template>
      <AuthorList :authors="sortedAuthors"></AuthorList>
      <ReviewerList :reviewers="sortedReviewers"></ReviewerList>
    </v-flex>
  </v-layout>
</template>

<script>
import { db } from '@/firebase/config';
import AuthorList from '@/components/contents/author/AuthorList.vue';
import ReviewerList from '@/components/contents/reviewer/List.vue';

export default {
  components: { AuthorList, ReviewerList },
  mounted() {
    this.$bind(
      'authors',
      db
        .collection('authors')
        .where('contents', 'array-contains', this.content.id),
    );
    this.$bind(
      'reviewers',
      db
        .collection('reviewers')
        .where('contents', 'array-contains', this.content.id),
    );
  },
  data: () => ({
    loaded: false,
    authors: [],
    reviewers: [],
  }),
  props: {
    content: { type: Object },
  },
  computed: {
    sortedAuthors() {
      const authorsCopy = this.authors.slice();
      authorsCopy.sort((a, b) => a.name.localeCompare(b.name));
      return authorsCopy;
    },
    sortedReviewers() {
      const reviewersCopy = this.reviewers.slice();
      reviewersCopy.sort((a, b) => a.name.localeCompare(b.name));
      return reviewersCopy;
    },
    isMobile() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
      ];

      return toMatch.some(toMatchItem => navigator.userAgent.match(toMatchItem));
    },
  },
  methods: {
    didTapDownloadFile() {
      window.open(this.content.url);
    },
  },
};
</script>

<style scoped>
.pdf {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.header {
  text-align: justify;
  width: 100%;
  color: black;
  padding-top: 10px;
}
</style>
